<template>
	<div class="app-top-bar__search-wrapper">
		<input
			class="app-top-bar__search"
			type="text"
			v-model="searchText"
			@input="filterSearching"
			placeholder="Search"
		/>
		<Icon type="search" color="var(--accent-color)" :size="30" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	data() {
		return {
			searchText: this.search,
		}
	},
	computed: {
		...mapGetters('app', ['search']),
	},
	methods: {
		...mapActions('app', ['setSearch', 'clearSearch']),

		filterSearching(e) {
			this.setSearch(e.target.value)
		},
	},
	watch: {
		$route() {
			this.searchText = ''
			this.clearSearch()
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	&__search-wrapper {
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		flex-grow: 1;
		max-height: 40px;
		padding: 12px 10px;
		border-radius: 8px;
		max-width: 590px;

		@media (max-width: 1024px) {
			max-width: 274px;
		}

		@media (max-width: 768px) {
			max-width: none;
			background: #fff;
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: #fff;
			border-radius: 8px;
			z-index: -1;
		}
	}

	&__search {
		flex-grow: 1;
		font-size: 16px;
		line-height: 19.5px;
		font-family: Montserrat, sans-serif;
		color: var(--accent-color);
		position: relative;

		&::placeholder {
			color: var(--accent-color);
		}

		&:focus {
			outline: none;
		}

		@media (max-width: 768px) {
			color: var(--accent-color);
		}
	}
}
</style>
